/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_mobile_analytics_app_id": "11c83e20dd4e42d2970ba343fdf17a8d",
    "aws_mobile_analytics_app_region": "eu-central-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "11c83e20dd4e42d2970ba343fdf17a8d",
            "region": "eu-central-1"
        }
    },
    "aws_appsync_graphqlEndpoint": "https://lubq2ts5wvhwrnqidnpeolwlx4.appsync-api.eu-north-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-north-1:fa9fb385-92a2-476a-848e-ce436a058b46",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_NMMWKdXE5",
    "aws_user_pools_web_client_id": "46lvg459n18uqdhgtv1uv50ujm",
    "oauth": {
        "domain": "logycore-stage.auth.eu-north-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://logycore.com/app/,https://dev.logycore.com:5173/app/,https://stage.logycore.com/app/",
        "redirectSignOut": "https://logycore.com/app/,https://dev.logycore.com:5173/app/,https://stage.logycore.com/app/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "jsmdev-buck154503-stage",
    "aws_user_files_s3_bucket_region": "eu-north-1"
};


export default awsmobile;
